
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[region]/[resort]/boende",
      function () {
        return require("private-next-pages/[region]/[resort]/boende.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[region]/[resort]/boende"])
      });
    }
  